import { render, staticRenderFns } from "./RadioApi.vue?vue&type=template&id=a10569b2&"
import script from "./RadioApi.vue?vue&type=script&lang=js&"
export * from "./RadioApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports